import React from "react";
import "./tl404Page.css";

const Tl404Page = () => {
  return (
    <div className="stumbled-screen">
      <div className="stumbled-box">
        <h2 className="tl404-oops">Oops!</h2>
        <p className="tl404-line">This message wasn't ready to be delivered.</p>
        <p className="tl404-line">It seems like the URL you're trying to reach is incomplete or unavailable.</p>
        <p className="tl404-line">We apologize for the inconvenience.</p>
        <p className="tl404-line">Please double-check the URL or reach out to the sender for the complete link.</p>
      </div>
    </div>
  );
};

export default Tl404Page;
